import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { setUnauthorizedHandler } from '../api/client';
import { useSession } from '../features/auth/useAuth';

/**
 * Route guard plus the 401 interceptor's landing point: any request that comes back
 * unauthenticated (including a 12-hour idle session expiry) sends the admin to Login.
 */
export function RequireSession({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const session = useSession();

  useEffect(() => {
    setUnauthorizedHandler(() => navigate('/login', { replace: true }));
    return () => setUnauthorizedHandler(null);
  }, [navigate]);

  if (session.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-[13px] text-ink-muted">
        <span role="status">Checking your session…</span>
      </div>
    );
  }

  if (!session.data) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
